
import ServicesHeader from '@/components/components-services/ServicesHeader.vue'
import LoginDialog from '@/components/dialogs/LoginDialog.vue'
import SignUpDialog from '@/components/dialogs/SignUpDialog.vue'

import { defineComponent } from 'vue'
export default defineComponent({
  name: 'ServicesHeroSection',
  props: ['onRequest'],
  components: {
    ServicesHeader,
    LoginDialog,
    SignUpDialog,
  },
  data: () => ({
    isLeaveRequestModalOpen: false,
    showLoginDialog: false,
    showRegDialog: false,
  }),
  methods: {
    onClickLogin() {
      this.showLoginDialog = !this.showLoginDialog
    },
    onClickReg() {
      this.showRegDialog = !this.showRegDialog
    },
    onClickRequest() {
      this.isLeaveRequestModalOpen = !this.isLeaveRequestModalOpen
    },
  },
})
